/**
 * http.js
 * 封装axios，
 * 调用方法:
 * http.get('/api/enquiry/web/query',{id:1}).then((res)=>{你的操作})
 * http.post('/api/enquiry/web/update',{id:1}).then((res)=>{你的操作})
 * http.postFormData('/api/enquiry/web/update',{id:1,file:file}).then((res)=>{你的操作})
 */
import axios from 'axios';
import { decrypt } from './js/2222.js';
// 设置全局默认请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

const service = axios.create({
  baseURL: process.env.VUE_APP_REQUEST_BASE_URL,
  timeout: parseInt(process.env.VUE_APP_REQUEST_TIMEOUT) || 5000
});

export default {
  /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  get(url, params) {
    return new Promise((resolve, reject) => {
      let _parameter = {};
      if (process.env.NODE_ENV != 'production') {
        _parameter = Object.assign({ jm: '1' }, params);
      } else {
        _parameter = params || {};
      }
      service
        .get(url, {
          headers: {},
          params: _parameter
        })
        .then((res) => {
          if (typeof res.data == 'string') {
            let json = JSON.parse(decrypt(res.data));
            if (typeof json == 'object') {
              if (json.code - 0 > 200 && json.code - 0 < 300) {
                window.$vue.$message({
                  message: json.message,
                  type: 'warning'
                });
                return;
              }
              resolve(JSON.parse(decrypt(res.data)));
            } else {
              resolve(decrypt(res.data));
            }
          } else {
            if (res.data.code - 0 > 200 && res.data.code - 0 < 300) {
              //请求不成功时拦截提醒
              window.$vue.$message({
                message: res.data.message,
                type: 'warning'
              });
              return;
            }
            resolve(res.data);
          }
        })
        .catch((err) => {
          window.$vue.$message.error(err.message || '接口返回异常');
          reject(decrypt(err));
        });
    });
  },
  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} data [请求时携带的参数]
   */
  post(url, data, lodding = true) {
    return new Promise((resolve, reject) => {
      let _parameter = {};
      if (process.env.NODE_ENV != 'production') {
        _parameter = Object.assign({ jm: '1' }, data);
      } else {
        _parameter = data || {};
      }
      service
        .post(url, _parameter || {}, {
          headers: {},
          transformRequest: [
            function (data) {
              // 对 data 进行任意转换处理
              const formData = new FormData();
              Object.keys(data).forEach((key) => {
                formData.append(key, data[key]);
              });
              return formData;
            }
          ]
        })
        .then((res) => {
          if (typeof res.data == 'string') {
            let json = JSON.parse(decrypt(res.data));
            if (typeof json == 'object') {
              if (json.code - 0 > 200 && json.code - 0 < 300) {
                window.$vue.$message({
                  message: json.message,
                  type: 'warning'
                });
                return;
              }
              resolve(json);
            } else {
              resolve(decrypt(res.data));
            }
          } else {
            if (res.data.code - 0 > 200 && res.data.code - 0 < 300) {
              //请求不成功时拦截提醒
              window.$vue.$message({
                message: res.data.message,
                type: 'warning'
              });
              return;
            }
            resolve(res.data);
          }
        })
        .catch((err) => {
          window.$vue.$message.error(err.message || '接口返回异常');
          reject(decrypt(err));
        });
    });
  },
  /**
   * postFormData方法，对应post请求，用来提交文件+数据
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  postFormData(url, params) {
    return new Promise((resolve, reject) => {
      let _parameter = {};
      if (process.env.NODE_ENV != 'production') {
        _parameter = Object.assign({ jm: '1' }, params);
      } else {
        _parameter = params || {};
      }
      service({
        headers: {},
        transformRequest: [
          function (data) {
            // 在请求之前对data传参进行格式转换
            const formData = new FormData();
            Object.keys(data).forEach((key) => {
              formData.append(key, data[key]);
            });
            return formData;
          }
        ],
        url: url,
        method: 'post',
        data: _parameter
      })
        .then((res) => {
          if (typeof res.data == 'string') {
            let json = JSON.parse(decrypt(res.data));
            if (typeof json == 'object') {
              if (json.code - 0 > 200 && json.code - 0 < 300) {
                window.$vue.$message({
                  message: json.message,
                  type: 'warning'
                });
                return;
              }
              resolve(JSON.parse(decrypt(res.data)));
            } else {
              resolve(decrypt(res.data));
            }
          } else {
            if (res.data.code - 0 > 200 && res.data.code - 0 < 300) {
              //请求不成功时拦截提醒
              window.$vue.$message({
                message: res.data.message,
                type: 'warning'
              });
              return;
            }
            resolve(res.data);
          }
        })
        .catch((err) => {
          window.$vue.$message.error(err.message || '接口返回异常');
          reject(decrypt(err));
        });
    });
  },

  his(url, data, token) {
    return new Promise((resolve, reject) => {
      service
        .post(url, data, {
          headers: {
            token: token,
            Accept: 'application/json;charset=UTF-8',
            'Content-Type': 'application/json;charset=UTF-8'
          }
        })
        .then((res) => {
          if (res.status === 200) {
            resolve(res.data);
          } else {
            window.$vue.$message.error('请求错误，请联系管理员');
          }
        })
        .catch((err) => {
          window.$vue.$message.error(err.message || '接口返回异常');
          reject(decrypt(err));
        });
    });
  },
  his1(url, data, token) {
    return new Promise((resolve, reject) => {
      service
        .get(url, {
          headers: {
            token: token,
            Accept: 'application/json;charset=UTF-8',
            'Content-Type': 'application/json;charset=UTF-8'
          }
        })
        .then((res) => {
          if (res.status === 200) {
            resolve(res.data);
          } else {
            window.$vue.$message.error('请求错误，请联系管理员');
          }
        })
        .catch((err) => {
          window.$vue.$message.error(err.message || '接口返回异常');
          reject(decrypt(err));
        });
    });
  }
};
